import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './AdminEntregas.css'; // Estilos premium

const AdminEntregas = () => {
  const [ventas, setVentas] = useState([]);
  const [envios, setEnvios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [generando, setGenerando] = useState({});

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      setLoading(true);
      const [ventasRes, enviosRes] = await Promise.all([
        api.get('/ventas'),
        api.get('/envios')
      ]);
      
      // Ventas con dirección y sin guía
      const ventasConEnvio = ventasRes.data.filter(v => v.cliente_direccion && !v.guia_estafeta);
      
      setVentas(ventasConEnvio);
      setEnvios(enviosRes.data);
    } catch (error) {
      console.warn('Cargando datos de prueba (Mock) por error en API:', error.message);
      // 🔥 Red de Seguridad: Datos de Prueba si el backend falla
      setVentas([
        { id: 101, folio: 'VNT-00101', cliente_nombre: 'Roberto Sánchez', cliente_direccion: 'Calle Reforma 123, Col. Centro', cliente_ciudad: 'Puebla', cliente_estado: 'PUE', cliente_cp: '72000', total: 1500 },
        { id: 102, folio: 'VNT-00102', cliente_nombre: 'Ana Martínez', cliente_direccion: 'Av. Insurgentes Sur 45', cliente_ciudad: 'Ciudad de México', cliente_estado: 'CDMX', cliente_cp: '06000', total: 3200 },
        { id: 103, folio: 'VNT-00103', cliente_nombre: 'Carlos Gómez', cliente_direccion: 'Calle 5 de Mayo 89', cliente_ciudad: 'Xicotepec', cliente_estado: 'PUE', cliente_cp: '73080', total: 850 }
      ]);
      setEnvios([
        { id: 1, folio: 'VNT-00098', cliente_nombre: 'Juan Pérez', guia: 'EST-9876543210', carrier: 'estafeta', costo: 150.00, fecha_envio: '2026-05-12T10:00:00Z', estatus: 'en_transito', tracking_url: 'https://estafeta.com/tracking' },
        { id: 2, folio: 'VNT-00099', cliente_nombre: 'María López', guia: 'FDX-1234567890', carrier: 'fedex', costo: 185.50, fecha_envio: '2026-05-11T15:30:00Z', estatus: 'entregado', tracking_url: 'https://fedex.com/tracking' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const calcularPeso = (venta) => {
    // Asumiendo que cada $100 pesos equivalen a 1kg aprox
    return Math.max(1, Math.round(venta.total / 100));
  };

  const generarGuia = async (venta) => {
    setGenerando(prev => ({ ...prev, [venta.id]: true }));

    try {
      const data = {
        ventaId: venta.id,
        cp_destino: venta.cliente_cp,
        peso: calcularPeso(venta),
        valor_declarado: venta.total,
        nombre: venta.cliente_nombre,
        telefono: venta.cliente_telefono || '0000000000',
        email: venta.cliente_email || 'cliente@email.com',
        direccion: venta.cliente_direccion,
        ciudad: venta.cliente_ciudad,
        estado: venta.cliente_estado || 'PUE',
        carrier: 'estafeta',
        service: 'ground', 
        largo: 30, alto: 20, ancho: 15
      };

      const response = await api.post('/envios/generar-guia', data);

      if (response.data.success) {
        alert(`✅ Guía generada exitosamente:\n📦 Número: ${response.data.data.guia}\n💰 Costo: $${response.data.data.precio}`);
        cargarDatos();
      } else {
        throw new Error(response.data.error || 'No se pudo generar la guía');
      }
    } catch (error) {
      console.error('❌ Error detallado:', error);
      
      // Simulación de éxito si estamos usando Mock Data (para que veas cómo funciona visualmente)
      setTimeout(() => {
        const confirmacion = window.confirm(`⚠️ API de envíos desconectada.\n\nSimular generación exitosa de guía para la venta ${venta.folio}?`);
        if(confirmacion) {
            // Removemos de pendientes y pasamos a generados localmente
            setVentas(ventas.filter(v => v.id !== venta.id));
            setEnvios([{
                id: Date.now(), folio: venta.folio, cliente_nombre: venta.cliente_nombre,
                guia: `SIM-${Math.floor(Math.random() * 1000000000)}`, carrier: 'estafeta', 
                costo: 165.00, fecha_envio: new Date().toISOString(), estatus: 'creado', tracking_url: '#'
            }, ...envios]);
            alert('✅ Guía simulada correctamente.');
        }
        setGenerando(prev => ({ ...prev, [venta.id]: false }));
      }, 1500);

    }
  };

  const verEtiqueta = (url) => {
    if(url === '#') alert('Etiqueta simulada. No hay URL real.');
    else window.open(url, '_blank');
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return 'N/A';
    return new Date(fecha).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  if (loading) {
    return (
        <div className="admin-loading-screen">
            <div className="coffee-spinner">📦</div>
            <p>Cargando módulo de logística...</p>
        </div>
    );
  }

  return (
    <div className="admin-page-container">
      <div className="admin-header-flex">
        <div>
          <h1>🚚 Logística y Envíos</h1>
          <p>Genera guías de paquetería y administra las entregas de "El Catador".</p>
        </div>
      </div>

      {/* Tarjetas de Estadísticas Logísticas */}
      <div className="stats-grid" style={{ marginBottom: '2.5rem' }}>
        <div className="stat-card">
          <div className="stat-icon-wrapper warning">⏳</div>
          <div className="stat-info">
            <h3>Pendientes de Envío</h3>
            <p className="stat-number">{ventas.length}</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon-wrapper success">📦</div>
          <div className="stat-info">
            <h3>Guías Generadas</h3>
            <p className="stat-number">{envios.length}</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon-wrapper info">🚚</div>
          <div className="stat-info">
            <h3>En Tránsito</h3>
            <p className="stat-number">{envios.filter(e => e.estatus === 'en_transito').length}</p>
          </div>
        </div>
      </div>

      {/* SECCIÓN 1: Ventas Pendientes */}
      <section className="logistica-section">
        <div className="section-title-wrapper">
          <h2>⚠️ Requieren Guía de Envío ({ventas.length})</h2>
          <p>Estos pedidos ya fueron pagados y están listos para ser empaquetados.</p>
        </div>

        <div className="table-wrapper mb-4">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Folio</th>
                <th>Cliente</th>
                <th>Destino</th>
                <th>Código Postal</th>
                <th>Peso Est.</th>
                <th className="text-right">Acción</th>
              </tr>
            </thead>
            <tbody>
              {ventas.map(v => (
                <tr key={v.id} className={generando[v.id] ? 'row-loading' : ''}>
                  <td className="font-mono fw-bold text-primary">{v.folio}</td>
                  <td><strong>{v.cliente_nombre}</strong></td>
                  <td>
                    <div className="direccion-cell">
                      <span>{v.cliente_direccion}</span>
                      <small>{v.cliente_ciudad}, {v.cliente_estado}</small>
                    </div>
                  </td>
                  <td className="font-mono">{v.cliente_cp}</td>
                  <td>{calcularPeso(v)} kg</td>
                  <td className="text-right">
                    <button 
                      className={`btn-action ${generando[v.id] ? 'loading' : 'primary'}`}
                      onClick={() => generarGuia(v)}
                      disabled={generando[v.id]}
                    >
                      {generando[v.id] ? '⏳ Generando...' : '⚙️ Crear Guía'}
                    </button>
                  </td>
                </tr>
              ))}
              {ventas.length === 0 && (
                <tr>
                  <td colSpan="6" className="empty-state">
                    🎉 ¡Excelente! No hay envíos pendientes por procesar.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* SECCIÓN 2: Envíos Generados */}
      <section className="logistica-section mt-5">
        <div className="section-title-wrapper">
          <h2>📦 Historial de Envíos ({envios.length})</h2>
          <p>Seguimiento de paquetes que ya tienen guía asignada.</p>
        </div>

        <div className="table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Folio Pedido</th>
                <th>Cliente</th>
                <th>Paquetería</th>
                <th>No. de Guía</th>
                <th>Costo Envío</th>
                <th>Fecha Emisión</th>
                <th>Estatus</th>
                <th className="text-right">Etiqueta</th>
              </tr>
            </thead>
            <tbody>
              {envios.map(e => (
                <tr key={e.id}>
                  <td className="font-mono text-muted">{e.folio || 'N/A'}</td>
                  <td><strong>{e.cliente_nombre || 'N/A'}</strong></td>
                  <td>
                    <span className={`carrier-badge ${e.carrier?.toLowerCase()}`}>
                      {e.carrier}
                    </span>
                  </td>
                  <td className="font-mono fw-bold">{e.guia}</td>
                  <td style={{ color: '#D32F2F', fontWeight: '600' }}>
                    -${e.costo?.toFixed(2)}
                  </td>
                  <td>{formatearFecha(e.fecha_envio)}</td>
                  <td>
                    <span className={`status-pill ${e.estatus}`}>
                      {e.estatus.replace('_', ' ')}
                    </span>
                  </td>
                  <td className="text-right">
                    {e.tracking_url ? (
                      <button 
                        className="btn-icon-action info"
                        title="Imprimir/Ver Etiqueta"
                        onClick={() => verEtiqueta(e.tracking_url)}
                        style={{ width: 'auto', padding: '0 10px', fontSize: '0.9rem' }}
                      >
                        📄 Imprimir
                      </button>
                    ) : (
                      <span className="text-muted" style={{ fontSize: '0.85rem' }}>Sin enlace</span>
                    )}
                  </td>
                </tr>
              ))}
              {envios.length === 0 && (
                <tr>
                  <td colSpan="8" className="empty-state">
                    No se han generado guías históricas.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default AdminEntregas;